/** Money is handled as integer cents everywhere on the wire and in the DB. */
export type Cents = number;

export function toCents(amount: number | string): Cents {
  const n = typeof amount === 'string' ? Number(amount.replace(',', '.')) : amount;
  return Math.round(n * 100);
}

export function fromCents(cents: Cents): number {
  return cents / 100;
}

/** Dutch formatting: € 3.124,64 */
export function formatEur(cents: Cents, opts: { decimals?: boolean } = {}): string {
  const decimals = opts.decimals ?? true;
  const value = cents / 100;
  const s = new Intl.NumberFormat('nl-NL', {
    minimumFractionDigits: decimals ? 2 : 0,
    maximumFractionDigits: decimals ? 2 : 0,
  }).format(value);
  return `€ ${s}`;
}

export interface LineInput { quantity: number; unitPriceCents: Cents; vatRate: number; discount?: boolean }

export interface Totals { subtotalCents: Cents; vatCents: Cents; totalCents: Cents; discountCents: Cents }

/**
 * Line total = qty × unit price (negated for discount lines). VAT is computed per
 * line and rounded per line, matching how e-Boekhouden and most Dutch invoicing
 * tools round.
 */
export function lineTotalCents(l: LineInput): Cents {
  const raw = Math.round(l.quantity * l.unitPriceCents);
  return l.discount ? -Math.abs(raw) : raw;
}

export function computeTotals(lines: LineInput[]): Totals {
  let subtotal = 0, vat = 0, discount = 0;
  for (const l of lines) {
    const t = lineTotalCents(l);
    subtotal += t;
    vat += Math.round((t * l.vatRate) / 100);
    if (l.discount) discount += Math.abs(t);
  }
  return { subtotalCents: subtotal, vatCents: vat, totalCents: subtotal + vat, discountCents: discount };
}
